// extracted by mini-css-extract-plugin
export default {"root":"root---bqTnW","label":"label---cnjmZ","separator":"separator---KOvm1","patronGroup":"patronGroup---YHON5","expiredMessage":"expiredMessage---SQFj4"};